$(document).ready(function() {

    $(".link-unhook").on("click", function(e){
        e.preventDefault();
        $(this).parents(".dropdown-select").find("input").prop('checked', false);
    });

    $('.carousel').carousel({
        interval: 5000
    });

    $(document).on('click', '#open-parent-pageList', function (e) {
        e.preventDefault();
        var categories = getValueOfSelectedCheckbox(),
            url = $(this).attr('href');

        if(categories.length != 0){
            window.location.href = url+'?categorie='+categories;
        }else{
            window.location.href = url
        }
    });

    function getValueOfSelectedCheckbox(){
        return $('#dropdownFilterCat input[type="checkbox"]:checked').map(function(){
            return $(this).val();
        }).get()
    }
});